// extracted by mini-css-extract-plugin
export default {"container":"geGht0","fullWidth":"bIn5_D"};